import {SeriesType} from '@dms/api/core';

export const RECORD_AUDIT_SERIES_TYPE: SeriesType = 'general/record_audit';
